import { useEffect } from "react";

const DEFAULT_TITLE = "Partner | apoteka.rs";
const DEFAULT_FAVICON = "/favicon.svg";
const NOTIFY_FAVICON = "/favicon-notify.svg";

export const useTabNotifications = (count: number) => {
  useEffect(() => {
    // Update title
    document.title = count > 0 ? `(${count}) ${DEFAULT_TITLE}` : DEFAULT_TITLE;

    // Update favicon
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      document.head.appendChild(link);
    }

    link.setAttribute("href", count > 0 ? NOTIFY_FAVICON : DEFAULT_FAVICON);

    return () => {
      document.title = DEFAULT_TITLE;
      if (link) {
        link.setAttribute("href", DEFAULT_FAVICON);
      }
    };
  }, [count]);
};
